/**
  * 用户 接口的统一出口
  */
 import axios from '../http' // 导入http中创建的axios实例
 import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来
 
 const index = {
    // 头条推荐类型
    pushtype (params) {
        return axios.get('/home/pushtype/list', { params: params })
    },
	// 头条分类
	cateList (params) {
		return axios.get('/home/cate/list', { params: params })
	},
	// 头条列表
	headlineList (params) {
		return axios.get('/home/headline/list', { params: params })
	},
	// 头条详情
	headlineinfo (params) {
		return axios.get('/home/headline/info', { params: params })
	},
	// 添加头条
	create (params){
		return axios.post('/home/headline/create', qs.stringify(params))
	},
	// 添加评论
	comment (params){
		return axios.post('/home/comment/create', qs.stringify(params))
	},
	// 收藏
	collect (params){
		return axios.post('/home/headline/collect', qs.stringify(params))
	},
	// 点赞
	like (params){
		return axios.post('/home/headline/like', qs.stringify(params))
	},
    
 }
 
 // 导出接口
 export default index